import { createSelector } from 'reselect';
import { AppState, Loadable } from '../../types';
import { StateUser, StateListUsers, CurrentUserState } from './types';
import { PromotionCode, User } from '../../../types/items';

export const selectUserList = (state: AppState): StateListUsers => state.user.list;

export const selectCurrentUser = (state: AppState): CurrentUserState => state.user.current;

export const selectUser = (state: AppState): StateUser => state.user.selected;

export const selectIsCurrentUser = createSelector(
  selectCurrentUser,
  selectUser,
  (currentUser, selectedUser): boolean => {
    return Boolean(currentUser.data?.id === selectedUser.data?.id);
  },
);

export const selectRelativeUser = createSelector(
  selectCurrentUser,
  selectUser,
  selectIsCurrentUser,
  (currentUser, selectedUser, isCurrentUser): Loadable<User> => {
    return isCurrentUser ? currentUser : selectedUser;
  },
);

export const selectIsAdmin = (state: AppState): boolean => {
  if (state && state.user) {
    return state.user.current.data?.is_super_admin || state.user.current.data?.is_admin || false;
  }
  return false;
};

export const selectIsSuperAdmin = (state: AppState): boolean => {
  if (state && state.user) {
    return state.user.current.data?.is_super_admin || false;
  }
  return false;
};

export const selectUserName = createSelector(
  selectUser,
  (state) => state.data?.username,
);

export const selectAppliedPromoCode = createSelector(
  selectCurrentUser,
  (state): PromotionCode | null => state.data?.ref?.active_subscription?.promotion_code || null,
);
